// Add Required Styles
var css = document.createElement( "style" );
css.innerHTML = '#personalization {display: none; margin-left: 8px;} #userImg { width: 32px; vertical-align: middle; margin-left: 5px;}';
document.head.appendChild( css );

const startPersonalization = function() {
  // Check local storage for items
  if ( window.localStorage.getItem('homeAsapImage') && window.localStorage.getItem('homeAsapFName') ) {
    const userImg = window.localStorage.getItem( 'homeAsapImage' );
    const fName = window.localStorage.getItem( 'homeAsapFName' );
    personalize( fName, userImg );
  } 
  else {
    readLogin();
  }

  function readLogin() {
    var autoAccessToken = ''
    window.homeasapTest = window.location.href.indexOf('test') > -1;
    var apiRoot = 'https://api.' + ( window.homeasapTest ? 'test' : '' ) + 'homeasap.com/NPlay.Services.NPlayApi/api/';

    initiateHomeASAPOverride();

    function initiateHomeASAPOverride() {
      var guid = '';
      try {
          guid = window.sessionStorage.getItem('guid');
          window.sessionStorage.removeItem('guid');
      } catch (ex) {}
      if (getUrlParameter('guid') || guid) {
          autoAccessToken = getUrlParameter('guid') || guid;
          if (!autoAccessToken.match(/^ha/)) {
              autoAccessToken = 'ha-aa_' + autoAccessToken;
          }
          authAPI(autoAccessToken, true);
      } else {
          // homeasap detection 
          var agentDataIFrame = document.createElement('iframe')
          agentDataIFrame.src = "https://" + (window.homeasapTest ? 'test' : '') + "homeasap.com/iframe-detect-agent.html?origin=" + window.location.origin;
          agentDataIFrame.style.width = "0"
          agentDataIFrame.style.height = "0"
          agentDataIFrame.style.position = "absolute"
          agentDataIFrame.style.top = "-10000px"
          document.body.appendChild(agentDataIFrame)

          window.addEventListener("message", function(e) {
              if (typeof e.data === 'string') {
                  if (e.data.match(/^HOMEASAP_DETECT_AGENT:SUCCESS::/)) {
                      autoAccessToken = e.data.replace('HOMEASAP_DETECT_AGENT:SUCCESS::', '').replace(/^"/, '').replace(/"$/, '');
                      authAPI(autoAccessToken, true);
                  } else if (e.data.match(/^HOMEASAP_DETECT_AGENT:FAILED::/)) {
                      console.log('Home ASAP: Personalization failed.');
                  }
              }
          }, false)
      }
    }

    function authAPI(token, isDetected) {
      console.log('Welcome!  Fetching your information.... ');

      window.jQuery.ajax({
          url: apiRoot + "agentauth",
          type: "POST",
          dataType: 'json',
          xhrFields: {
              withCredentials: true
          },
          crossDomain: true,
          data: {
              '': token
          },
          success: function(token) {
              agentAPI();
          },
          error: function(jqXHR, status, thrownError) {
            console.log('Home ASAP: Personalization failed.');
          }
      });
    }

    function agentAPI() {
      window.jQuery.ajax({
        url: apiRoot + "agent",
        type: "GET",
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true,
        success: function( data ) {
          let fName = data.firstName;
          let userImg = data.profile_image;
          console.log( "Agent login successful", data );

          personalize(fName, userImg);
          // Store agent info for future use
          window.localStorage.setItem( 'homeAsapImage', userImg );
          window.localStorage.setItem( 'homeAsapFName', fName );
        },
        error: function() {
          console.log('Home ASAP: Personalization failed.');
        }
      });
    }

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
  }

  function personalize ( fName, userImg ) {
    document.getElementById('personalization').style.display = 'inline-block';
    document.getElementById( 'userFirstName' ).innerText = fName;
    document.getElementById( 'userImg' ).src = userImg;
    jQuery('#readLoginButton').hide();
    jQuery('#dirJoinBtn').hide();
  }
};

window.jQuery(startPersonalization);
